export default __webpack_public_path__ + "static/media/1997.da1db488.png";